export default "__VITE_ASSET__c19a2e1d__"